export default {
  title: 'Trovare illustrazioni scientifiche',
  subTitle: 'Dalla più grande galleria di illustrazioni scientificamente accurate del mondo!',
  label: 'Cercate tra le nostre oltre 75.000 illustrazioni',
};
